import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import { CreateOrEditNotificationKeyDto, NotificationKeysServiceProxy, SubscriptionStartType } from '@shared/service-proxies/service-proxies';
import { ChatSignalrService } from 'app/shared/layout/chat/chat-signalr.service';
import * as moment from 'moment';
import { AppComponentBase } from 'shared/common/app-component-base';
import { SignalRHelper } from 'shared/helpers/SignalRHelper';
import { LinkedAccountsModalComponent } from '@app/shared/layout/linked-accounts-modal.component';
import { LoginAttemptsModalComponent } from '@app/shared/layout/login-attempts-modal.component';
import { ChangePasswordModalComponent } from '@app/shared/layout/profile/change-password-modal.component';
import { ChangeProfilePictureModalComponent } from '@app/shared/layout/profile/change-profile-picture-modal.component';
import { MySettingsModalComponent } from '@app/shared/layout/profile/my-settings-modal.component';
import { NotificationSettingsModalComponent } from '@app/shared/layout/notifications/notification-settings-modal.component';
import { UserNotificationHelper } from '@app/shared/layout/notifications/UserNotificationHelper';
import { SignalrService } from '@shared/service-proxies/signalr.service';


// declare const Pushe: any;
// const pingCloudNotification = require('../assets/pingCloudNotification.js');
@Component({
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less']
})
export class AppComponent extends AppComponentBase implements OnInit {

    subscriptionStartType = SubscriptionStartType;
    theme: string;
    installationMode = true;

    @ViewChild('loginAttemptsModal', { static: true }) loginAttemptsModal: LoginAttemptsModalComponent;
    @ViewChild('linkedAccountsModal', { static: false }) linkedAccountsModal: LinkedAccountsModalComponent;
    @ViewChild('changePasswordModal', { static: true }) changePasswordModal: ChangePasswordModalComponent;
    @ViewChild('changeProfilePictureModal', { static: true }) changeProfilePictureModal: ChangeProfilePictureModalComponent;
    @ViewChild('mySettingsModal', { static: true }) mySettingsModal: MySettingsModalComponent;
    @ViewChild('notificationSettingsModal', { static: true }) notificationSettingsModal: NotificationSettingsModalComponent;
    @ViewChild('chatBarComponent', { static: false }) chatBarComponent;
    isQuickThemeSelectEnabled: boolean = this.setting.getBoolean('App.UserManagement.IsQuickThemeSelectEnabled');
    IsSessionTimeOutEnabled: boolean = this.setting.getBoolean('App.UserManagement.SessionTimeOut.IsEnabled') && this.appSession.userId != null;

    public constructor(
        injector: Injector,
        private _chatSignalrService: ChatSignalrService,
        private _notificationKeysServiceProxy: NotificationKeysServiceProxy,
        private _userNotificationHelper: UserNotificationHelper,
        private _signalrService: SignalrService
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this._userNotificationHelper.settingsModal = this.notificationSettingsModal;
        this.theme = abp.setting.get('App.UiManagement.Theme').toLocaleLowerCase();
        this.installationMode = UrlHelper.isInstallUrl(location.href);

        this.registerModalOpenEvents();

        this._signalrService.createHubConnection();
        // pingCloudNotification.pingCloudInit('17cf383a1b9f45d69d0dc6f3c27d2df8', '8.1.0.0');
        // pingCloudNotification.pingCloudSubscribe();
        // setTimeout(() => {
        //     pingCloudNotification.pingCloudNotification('سید علی آزمایش',
        //         'پیام جدیدی از سید علی آزمایش دریافت شد.',
        //         'https://alertmind.ir/_nuxt/img/logo.d85edb7.png',
        //         null,
        //         null,
        //         'rtl',
        //         'https://alertmind.ir',
        //         478966325,
        //         null,
        //         [
        //             { action: 'باز کردن', title: 'باز کردن' },
        //             { action: 'بستن', title: 'بستن' }
        //         ]);
        // }, 1500)
        //this.initPushe();
    }

    initPushe() {

        // Pushe.init("2eymz3rk74xzqyje");
        // Pushe.subscribe().then(() => {
        //     Pushe.getDeviceId().then((browserId: any) => {
        //         // var notificationKey = deviceId;
        //         // console.log(browserId, 'device Id');
        //         localStorage.setItem('deviceId', browserId);
        //         var notificationKey = new CreateOrEditNotificationKeyDto();
        //         notificationKey.deviceId = browserId;
        //         this._notificationKeysServiceProxy.createOrEdit(notificationKey)
        //             .subscribe(() => {
        //                 // this.notify.info(this.l('SavedSuccessfully'));
        //             });

        //     });
        // });
    }

    subscriptionStatusBarVisible(): boolean {
        return this.appSession.tenantId > 0 &&
            (this.appSession.tenant.isInTrialPeriod ||
                this.subscriptionIsExpiringSoon());
    }

    subscriptionIsExpiringSoon(): boolean {
        if (this.appSession.tenant.subscriptionEndDateUtc) {
            return moment().utc().add(AppConsts.subscriptionExpireNootifyDayCount, 'days') >= moment(this.appSession.tenant.subscriptionEndDateUtc);
        }

        return false;
    }

    registerModalOpenEvents(): void {
        abp.event.on('app.show.loginAttemptsModal', () => {
            this.loginAttemptsModal.show();
        });

        abp.event.on('app.show.linkedAccountsModal', () => {
            this.linkedAccountsModal.show();
        });

        abp.event.on('app.show.changePasswordModal', () => {
            this.changePasswordModal.show();
        });

        abp.event.on('app.show.changeProfilePictureModal', () => {
            this.changeProfilePictureModal.show();
        });

        abp.event.on('app.show.mySettingsModal', () => {
            this.mySettingsModal.show();
        });
    }

    getRecentlyLinkedUsers(): void {
        abp.event.trigger('app.getRecentlyLinkedUsers');
    }

    onMySettingsModalSaved(): void {
        abp.event.trigger('app.onMySettingsModalSaved');
    }
}
